// @flow

// Google analytics
import ReactGA from 'react-ga'

// Effect Managers
import { call, put } from 'redux-saga/effects'

// Action Creators
import { receiveAuthenticatedUser } from '../../actions'

// Controller
import controller from 'fc-ctrl-users'

// Utils
import traverse from 'fc-utils/traverse'

// Local
const getUserId: (any) => ?number = traverse(['model', 'id'])

// Exports
export default function* fetchAuthenticatedUser(): Generator<*, void, *> {
  const result = yield call(controller.read, {
    url: 'client/currentuser/',
  })

  const userId: ?number = getUserId(result)
  if (userId) {
    ReactGA.set({ userId })
    yield put(receiveAuthenticatedUser(userId))
  }

  return result
}
